/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Stats = class Stats {
  constructor(el) {
    this.el = el;
    this.viewDetailsLink = this.el.find(".view-details-link a");
    this.hideDetailsLink = this.el.find(".hide-details-link a");
    this.referralStatusScreen = this.el.find(".referral-status-row");

    this._bindEvents();
  }

  _bindEvents() {

    this.hideDetailsLink.on("click", event => {
      event.preventDefault();
      return this._hideDetails();
    });

    return this.viewDetailsLink.on("click", event => {
      event.preventDefault();
      return this._showDetails();
    });
  }

  _hideDetails() {
    this.referralStatusScreen.removeClass("expanded");
    return this.viewDetailsLink.removeClass('hide');
  }

  _showDetails() {
    this.viewDetailsLink.addClass('hide');

    this.referralStatusScreen.addClass("expanded");

    this.hideDetailsLink.focus();

    const offset = this.referralStatusScreen.offset().top;

    return window.parent.postMessage(`buyapowa:scroll:${offset}`, "*");
  }
};
